(function() {
  function getSlideOriginalPosition(slide) {
    if (!slide) return Number.POSITIVE_INFINITY;

    var originalPosition = parseInt(slide.getAttribute('data-original-position'), 10);
    return Number.isNaN(originalPosition) ? Number.POSITIVE_INFINITY : originalPosition;
  }

  function getAllSlides(swiperEl) {
    return Array.from(swiperEl.querySelectorAll('.swiper-slide'));
  }

  function getVisibleSlides(swiperEl) {
    return getAllSlides(swiperEl).filter(function(slide) {
      return !slide.classList.contains('is-filtered');
    }).sort(function(a, b) {
      return getSlideOriginalPosition(a) - getSlideOriginalPosition(b);
    });
  }

  function getActiveSlide(swiperEl, swiper) {
    var activeSlide = swiper && swiper.slides ? swiper.slides[swiper.activeIndex] : null;

    if (activeSlide && !activeSlide.classList.contains('is-filtered')) {
      return activeSlide;
    }

    return swiperEl.querySelector(
      '.swiper-slide.swiper-slide-active:not(.is-filtered), .swiper-slide.is-selected:not(.is-filtered)'
    );
  }

  /**
   * Show the featured-video bubble only when the first visible (non-filtered) slide is active.
   */
  function updateEdVideoStoryVisibility(swiperEl, swiper) {
    var wrapper = swiperEl.closest('.product__media-list-wrapper');
    if (!wrapper) return;

    var thumbs = wrapper.querySelectorAll('ed-video-thumbnail.ed-video-thumbnail');
    if (!thumbs.length) return;

    var visibleSlides = getVisibleSlides(swiperEl);
    var firstVisibleSlide = visibleSlides[0] || null;
    var activeSlide = getActiveSlide(swiperEl, swiper);
    var isFirstVisibleSlide = Boolean(
      firstVisibleSlide &&
      activeSlide &&
      getSlideOriginalPosition(firstVisibleSlide) === getSlideOriginalPosition(activeSlide)
    );

    wrapper.classList.toggle('is-ed-video-story-suppressed', !isFirstVisibleSlide);

    /* Inline styles survive stale theme CSS / CDN caches on the live storefront (class-only hides need fresh custom.css). */
    Array.prototype.forEach.call(thumbs, function (el) {
      if (!isFirstVisibleSlide) {
        el.style.visibility = 'hidden';
        el.style.pointerEvents = 'none';
      } else {
        el.style.visibility = '';
        el.style.pointerEvents = '';
      }
    });
  }

  function scheduleEdVideoStoryVisibilityUpdate(swiperEl, swiper) {
    requestAnimationFrame(function() {
      updateEdVideoStoryVisibility(swiperEl, swiper || swiperEl.swiper);
    });
  }

  function observeEdVideoStoryVisibility(swiperEl) {
    if (swiperEl.edVideoStoryObserver) return;

    var observer = new MutationObserver(function(mutations) {
      var shouldUpdate = mutations.some(function(mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'class';
      });

      if (shouldUpdate) {
        scheduleEdVideoStoryVisibilityUpdate(swiperEl);
      }
    });

    observer.observe(swiperEl, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    swiperEl.edVideoStoryObserver = observer;
  }

  function initProductMediaSwiper() {
    // Find all product media swiper containers
    const swiperContainers = document.querySelectorAll('[id*="-media-list"][data-transition-effect]');
    
    swiperContainers.forEach(function(swiperEl) {
      if (swiperEl.swiper || typeof Swiper === 'undefined') return;
      const productMedia = swiperEl.closest('.product__media');

      // Get settings from data attributes
      const transitionEffect = swiperEl.dataset.transitionEffect || 'slide';
      const enableVideoAutoplay = swiperEl.dataset.enableVideoAutoplay === 'true';
      const showArrowThumbnails = swiperEl.dataset.showArrowThumbnails === 'true';

      // Find initial slide index
      let initialSlide = 0;
      const allSlides = getAllSlides(swiperEl);
      const initialSlideElement =
        swiperEl.querySelector('.is-initial-selected:not(.is-filtered)') ||
        swiperEl.querySelector('.is-initial-selected');
      if (initialSlideElement) {
        initialSlide = allSlides.indexOf(initialSlideElement);
        if (initialSlide < 0) initialSlide = 0;
      }

      // Get visible slides (non-filtered)
      const visibleSlides = getVisibleSlides(swiperEl);
      const slidesCount = visibleSlides.length;

      const swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: transitionEffect,
        autoHeight: true,
        threshold: 10,
        initialSlide: initialSlide,
        allowTouchMove: slidesCount > 1,
        speed: 300,
        on: {
          init: function() {
            // Ensure videos have proper height on init
            this.updateAutoHeight();
            
            // Scroll initial thumbnail into view
            const activeSlide = this.slides[this.activeIndex];
            if (activeSlide) {
              const mediaId = activeSlide.getAttribute('data-media-id');
              const thumbnail = productMedia
                ? productMedia.querySelector(`.product__thumbnail-item[data-media-id="${mediaId}"]`)
                : null;
              if (thumbnail) {
                const thumbnailList = thumbnail.closest('.product__thumbnail-list');
                if (thumbnailList) {
                  setTimeout(() => {
                    const thumbnailRect = thumbnail.getBoundingClientRect();
                    const listRect = thumbnailList.getBoundingClientRect();
                    const scrollLeft = thumbnailList.scrollLeft;
                    
                    const thumbnailLeft = thumbnailRect.left - listRect.left + scrollLeft;
                    const thumbnailRight = thumbnailLeft + thumbnailRect.width;
                    const visibleLeft = scrollLeft;
                    const visibleRight = scrollLeft + listRect.width;
                    
                    if (thumbnailLeft < visibleLeft || thumbnailRight > visibleRight) {
                      const centerPosition = thumbnailLeft - (listRect.width / 2) + (thumbnailRect.width / 2);
                      thumbnailList.scrollTo({
                        left: centerPosition,
                        behavior: 'smooth'
                      });
                    }
                  }, 100);
                }
              }
            }
            
            // Play initial video if autoplay is enabled
            if (enableVideoAutoplay) {
              if (activeSlide) {
                const nativeVideo = activeSlide.querySelector('native-video');
                const externalVideo = activeSlide.querySelector('external-video');
                
                if (nativeVideo && nativeVideo.hasAttribute('autoplay')) {
                  setTimeout(() => {
                    if (typeof nativeVideo.play === 'function') {
                      nativeVideo.play();
                    }
                  }, 200);
                }
                
                if (externalVideo && externalVideo.hasAttribute('autoplay')) {
                  setTimeout(() => {
                    if (typeof externalVideo.play === 'function') {
                      externalVideo.play();
                    }
                  }, 200);
                }
              }
            }

            observeEdVideoStoryVisibility(swiperEl);
            scheduleEdVideoStoryVisibilityUpdate(swiperEl, this);
          },
          slideChange: function() {
            // Pause videos in previous slides
            this.slides.forEach((slide, index) => {
              if (index !== this.activeIndex) {
                const nativeVideo = slide.querySelector('native-video');
                const externalVideo = slide.querySelector('external-video');
                
                if (nativeVideo && typeof nativeVideo.pause === 'function') {
                  nativeVideo.pause();
                }
                if (externalVideo && typeof externalVideo.pause === 'function') {
                  externalVideo.pause();
                }
              }
            });

            // Update thumbnail selection and play video in active slide
            const activeSlide = this.slides[this.activeIndex];
            if (activeSlide) {
              const mediaId = activeSlide.getAttribute('data-media-id');
              const thumbnail = productMedia
                ? productMedia.querySelector(`.product__thumbnail-item[data-media-id="${mediaId}"]`)
                : null;
              if (thumbnail) {
                if (productMedia) {
                  productMedia.querySelectorAll('.product__thumbnail-item').forEach(thumb => {
                    thumb.removeAttribute('aria-current');
                  });
                }
                thumbnail.setAttribute('aria-current', 'true');
                
                // Scroll thumbnail into view
                const thumbnailList = thumbnail.closest('.product__thumbnail-list');
                if (thumbnailList) {
                  const thumbnailRect = thumbnail.getBoundingClientRect();
                  const listRect = thumbnailList.getBoundingClientRect();
                  const scrollLeft = thumbnailList.scrollLeft;
                  
                  // Calculate if thumbnail is outside visible area
                  const thumbnailLeft = thumbnailRect.left - listRect.left + scrollLeft;
                  const thumbnailRight = thumbnailLeft + thumbnailRect.width;
                  const visibleLeft = scrollLeft;
                  const visibleRight = scrollLeft + listRect.width;
                  
                  // Scroll to center the thumbnail if it's outside the visible area
                  if (thumbnailLeft < visibleLeft || thumbnailRight > visibleRight) {
                    const centerPosition = thumbnailLeft - (listRect.width / 2) + (thumbnailRect.width / 2);
                    thumbnailList.scrollTo({
                      left: centerPosition,
                      behavior: 'smooth'
                    });
                  }
                }
              }
              
              // Update dots navigation
              const dot = productMedia
                ? productMedia.querySelector(`.dots-nav__item[data-media-id="${mediaId}"]`)
                : null;
              if (dot) {
                if (productMedia) {
                  productMedia.querySelectorAll('.dots-nav__item').forEach(d => {
                    d.removeAttribute('aria-current');
                  });
                }
                dot.setAttribute('aria-current', 'true');
              }

              // Play video in active slide if autoplay is enabled
              if (enableVideoAutoplay) {
                const nativeVideo = activeSlide.querySelector('native-video');
                const externalVideo = activeSlide.querySelector('external-video');
                
                if (nativeVideo && nativeVideo.hasAttribute('autoplay')) {
                  // Native video will auto-play if autoplay attribute is present
                  // But we need to ensure it's visible first
                  setTimeout(() => {
                    if (typeof nativeVideo.play === 'function') {
                      nativeVideo.play();
                    }
                  }, 100);
                }
                
                if (externalVideo && externalVideo.hasAttribute('autoplay')) {
                  // External video uses untilVisible, but we can trigger play manually
                  setTimeout(() => {
                    if (typeof externalVideo.play === 'function') {
                      externalVideo.play();
                    }
                  }, 100);
                }
              }

              // Update height for videos after slide change
              const hasVideo = activeSlide.querySelector('.video-wrapper, .native-video, .external-video');
              if (hasVideo) {
                // Force update height after a small delay to ensure images are loaded
                setTimeout(() => {
                  this.updateAutoHeight();
                }, 50);
              }
            }

            scheduleEdVideoStoryVisibilityUpdate(swiperEl, this);
          },
          transitionEnd: function() {
            scheduleEdVideoStoryVisibilityUpdate(swiperEl, this);
          },
          imagesReady: function() {
            // Update height when images are ready
            this.updateAutoHeight();
          }
        }
      };

      // Add fade effect if needed
      if (transitionEffect === 'fade') {
        swiperConfig.fadeEffect = {
          crossFade: true
        };
      }

      // Add navigation if arrows are enabled
      if (showArrowThumbnails) {
        if (productMedia) {
          swiperConfig.navigation = {
            nextEl: productMedia.querySelector('.swiper-button-next'),
            prevEl: productMedia.querySelector('.swiper-button-prev'),
          };
        }
      }

      const swiper = new Swiper(swiperEl, swiperConfig);
      observeEdVideoStoryVisibility(swiperEl);
      scheduleEdVideoStoryVisibilityUpdate(swiperEl, swiper);

      // Handle thumbnail clicks
      if (productMedia) {
        productMedia.querySelectorAll('.product__thumbnail-item:not(.is-filtered)').forEach((thumbnail) => {
          thumbnail.addEventListener('click', function() {
            const mediaId = this.getAttribute('data-media-id');
            const slideElement = swiperEl.querySelector(`.swiper-slide[data-media-id="${mediaId}"]:not(.is-filtered)`);
            if (slideElement) {
              const slides = getAllSlides(swiperEl);
              const slideIndex = slides.indexOf(slideElement);
              if (slideIndex >= 0) {
                swiper.slideTo(slideIndex);
              }
            }
          });
        });

        // Handle dots navigation clicks
        productMedia.querySelectorAll('.dots-nav__item:not(.is-filtered)').forEach((dot) => {
          dot.addEventListener('click', function() {
            const mediaId = this.getAttribute('data-media-id');
            const slideElement = swiperEl.querySelector(`.swiper-slide[data-media-id="${mediaId}"]:not(.is-filtered)`);
            if (slideElement) {
              const slides = getAllSlides(swiperEl);
              const slideIndex = slides.indexOf(slideElement);
              if (slideIndex >= 0) {
                swiper.slideTo(slideIndex);
              }
            }
          });
        });
      }

      // Store swiper instance for later use
      swiperEl.swiper = swiper;
    });
  }

  // Handle variant change - slide to the variant's featured media
  function handleVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant || !variant.featured_media) return;

    const sourceForm =
      event.target instanceof Element ? event.target.closest('form') : null;
    const scopedSwiperEl = sourceForm && sourceForm.id
      ? document.querySelector(`product-media[form-id="${sourceForm.id}"] [id*="-media-list"][data-transition-effect]`)
      : null;
    const swiperEl = scopedSwiperEl || document.querySelector('[id*="-media-list"][data-transition-effect]');
    if (!swiperEl || !swiperEl.swiper) return;

    const swiper = swiperEl.swiper;
    const targetSlide = swiperEl.querySelector(`.swiper-slide[data-media-id="${variant.featured_media.id}"]:not(.is-filtered)`);
    
    if (targetSlide) {
      const slides = getAllSlides(swiperEl);
      const slideIndex = slides.indexOf(targetSlide);
      if (slideIndex >= 0) {
        if (swiper.activeIndex === slideIndex) {
          scheduleEdVideoStoryVisibilityUpdate(swiperEl, swiper);
        } else {
          swiper.slideTo(slideIndex);
        }
      }
    } else {
      scheduleEdVideoStoryVisibilityUpdate(swiperEl, swiper);
    }
  }

  // Wait for Swiper to be available
  function waitForSwiper(attempts = 0) {
    const maxAttempts = 15;
    
    if (typeof Swiper !== 'undefined') {
      initProductMediaSwiper();
    } else if (attempts < maxAttempts) {
      // Retry after a short delay
      setTimeout(() => waitForSwiper(attempts + 1), 50);
    } else {
      // Max attempts reached, abort
      console.warn('Swiper library not loaded after ' + maxAttempts + ' attempts. Product media swiper initialization aborted.');
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      waitForSwiper(0);
      document.addEventListener('variant:changed', handleVariantChange);
    });
  } else {
    waitForSwiper(0);
    document.addEventListener('variant:changed', handleVariantChange);
  }
})();
